import React from 'react';
import MeterBrands from './MeterBrands';
import QNom from './Q_nom';
import Diameters from './Diameters';

const Lists = () => {
  return (
    <div className="mt-24 container mx-auto px-4 py-8">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Q_NOM Section */}
        <div>
          <div className="mb-2">
            <h1 className="text-2xl font-semibold text-white bg-primary p-4 rounded-t-lg">Qn/m3</h1>
          </div>
          <div className="bg-white shadow-lg rounded-lg p-4">
            <QNom />
          </div>
        </div>

        {/* Meters Section */}
        <div>
          <div className="mb-2">
            <h1 className="text-2xl font-semibold text-white bg-primary p-4 rounded-t-lg">Veemõõtjad</h1>
          </div>
          <div className="bg-white shadow-lg rounded-lg p-4">
            <MeterBrands />
          </div>
        </div>

        {/* Diameters Section */}
        <div>
          <div className="mb-2">
            <h1 className="text-2xl font-semibold text-white bg-primary p-4 rounded-t-lg">Läbimõõdud</h1>
          </div>
          <div className="bg-white shadow-lg rounded-lg p-4">
            <Diameters />
          </div>
        </div>

      </div>
    </div>
  );
};

export default Lists;
